/**
 * State used in rendering ToastBody
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
